import * as React from 'react'
import { useTranslations } from 'next-intl'

import { postV1UsersPasswordResetsClient } from '@/generated/clients/axios/AuthenticationService'
import { parseResponseErrors } from 'utils/api-errors'

import AuthHeader from 'components/AuthHeader'
import ForgotPasswordForm from 'components/ForgotPasswordForm'
import SuccessMessage from 'components/SuccessMessage'

import { colors, media } from 'utils/style'

function ForgotPasswordPage() {
  const t = useTranslations()
  const [submitted, setSubmitted] = React.useState(false)

  async function handleSubmit(values: any, actions: any) {
    actions.setSubmitting(true)

    try {
      await postV1UsersPasswordResetsClient({
        user: {
          email: values.email,
        },
      })
      setSubmitted(true)
    } catch (error: any) {
      console.log('Error submitting forgot password request', error)

      const submitErrors = parseResponseErrors(error, t)
      if (submitErrors && Object.keys(submitErrors).length > 0) {
        actions.setErrors(submitErrors)
      }
    } finally {
      actions.setSubmitting(false)
    }
  }

  return (
    <div className="container">
      <AuthHeader />

      <div className="form">
        {submitted ? (
          <div className="success-message">
            <SuccessMessage
              title={t('forgotPasswordPage.success.title')}
              description={t('forgotPasswordPage.success.description')}
            />
          </div>
        ) : (
          <ForgotPasswordForm onSubmit={handleSubmit} />
        )}
      </div>

      <style jsx>{`
        .form {
          width: 100%;
          max-width: 377px;
          margin: 0 auto;
        }

        .success-message {
          margin-bottom: 30px;
        }

        @media (min-width: ${media.desktop}px) {
          .form {
            max-width: 483px;
            padding: 38px 53px 15px;
            border-radius: 6px;

            background: ${colors.white};
            box-shadow: 0px 10px 20px rgba(144, 144, 144, 0.1);
          }
        }
      `}</style>
    </div>
  )
}

ForgotPasswordPage.title = 'forgotPasswordPage.title'

export default ForgotPasswordPage
